var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Transition",
    {
      attrs: { name: "slide-top" },
      on: {
        "after-enter": _vm.onAfterEnterTransition,
        "after-leave": _vm.onAfterLeaveTransition
      }
    },
    [
      _vm.banner && !_vm.bannerDismissed
        ? _c(
            "div",
            {
              ref: "bannerEl",
              class: [
                "b-banner",
                _vm.banner.theme,
                _vm.banner.banner_class,
                {
                  "with-countdown": _vm.showCountdown,
                  "logged-in": _vm.loggedIn,
                  dismissable: _vm.banner.dismissable
                }
              ],
              on: { click: _vm.handleClick }
            },
            [
              _c("div", { staticClass: "container banner-content" }, [
                _c(
                  "div",
                  { staticClass: "banner-inner-content has-text-cta" },
                  [
                    _vm.iconComponent
                      ? _c("DynamicIcon", {
                          staticClass: "block",
                          attrs: { "icon-component": _vm.iconComponent }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "text",
                      domProps: { innerHTML: _vm._s(_vm.bannerText) }
                    }),
                    _vm._v(" "),
                    _vm.banner.call_to_action_text
                      ? _c("span", {
                          staticClass: "cta--text",
                          domProps: {
                            innerHTML: _vm._s(_vm.banner.call_to_action_text)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.banner.dismissable
                      ? _c(
                          "span",
                          {
                            staticClass: "close-wrapper",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.dismiss($event)
                              }
                            }
                          },
                          [
                            _c("DynamicIcon", {
                              staticClass: "block",
                              attrs: { "icon-component": "XIcon" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }